import i18n from "i18next";
import enGBMain from "../i18n/en-GB/main.json";
import zhCNMain from "../i18n/zh-CN/main.json";
import LanguageDetector from "i18next-browser-languagedetector";
import { getDomain } from "./commons";

const LANG_EN = "en-GB";
const LANG_CN = "zh-CN";

i18n.use(LanguageDetector).init({
    fallbackLng: {
        default: [LANG_CN],
        en: [LANG_EN],
        "en-US": [LANG_EN],
        zh: [LANG_CN],
    },
    ns: ["main"],
    defaultNS: "main",
    returnEmptyString: false,
    resources: {
        "en-GB": {
            main: enGBMain,
        },
        "zh-CN": {
            main: zhCNMain,
        },
    },
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
    detection: {
        order: ["querystring", "cookie", "navigator", "htmlTag"],
        lookupQuerystring: "lang",
        lookupCookie: "i18next",
        caches: ["cookie"],
        cookieMinutes: 60 * 24 * 30, // 30天
        cookieDomain: getDomain(),
        htmlTag: document.documentElement,
        cookieOptions: { path: "/" },
    },
});

function translate() {
    const args = Array.prototype.slice.call(arguments);
    return i18n.t.apply(i18n, args);
}

window.$t = translate;

function changeLang(langParam) {
    i18n.changeLanguage(langParam).then((t) => {
        window.location.reload();
    });
}

function getLang() {
    const lanMap = {
        "zh-CN": LANG_CN,
        "en-US": LANG_EN,
        "en-GB": LANG_EN,
        en: LANG_EN,
        zh: LANG_CN,
    };
    return lanMap[i18n.language];
}

export { i18n, getLang, changeLang, translate };
